import { render, staticRenderFns } from "./CookiePolicyView.vue?vue&type=template&id=50941fa6&"
import script from "./CookiePolicyView.vue?vue&type=script&lang=ts&"
export * from "./CookiePolicyView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50941fa6')) {
      api.createRecord('50941fa6', component.options)
    } else {
      api.reload('50941fa6', component.options)
    }
    module.hot.accept("./CookiePolicyView.vue?vue&type=template&id=50941fa6&", function () {
      api.rerender('50941fa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/CookiePolicyView.vue"
export default component.exports